import React from 'react';
import {connect} from "react-redux";
import classNames from 'classnames';
import $ from 'jquery';

import {
  toggleDesktopNavigation,
  setActiveNavigationNames,
  setModuleContextMenuType,
  setActiveNavigationFilter,
  setActiveNavigationFilterStepIndex,
  setNavigationViewType,
  setNavigationLoading,
  toggleNavItemPositionModal
} from "../../../actions/navigationFunctions";
import {setDefaultSelectionGroup, changeActivePartRelatedItemIndex} from "../../../actions/actionFunctions";
import DesktopNavigationCommon from "../../visComponents/navigation/desktopNavigationCommon";
import Z from "../core/zIndex";
import {getCurrentLayout} from "../../appLayout";

import LockedView from "../../common/lockedView";
import {ContentType} from "../../visComponents/constants";
import ContextMenu from "./contextMenu";
// import CabinetContextMenu from "./cabinetContextMenu";
import MobileMenuSelect from "../../visComponents/navigation/mobile/mobileMenuSelect";
import {setVisualizerTutorialStep, showVisualizerTutorial} from "../../../actions/tutorialFunctions";
import {Vanity} from "../core/parts/vanity";
import NavItemPositionModal from "../../visComponents/navigation/navItemPositionModal";

class DesktopNavigation extends DesktopNavigationCommon {

  bindCanvasClick = (event) => {
    const layout = getCurrentLayout();
    // const canvas = document.getElementById(this.props.canvasId);
    this.props.setHoveredLayer(event);

    if (document.hoveredLayer) {

      const layoutType = layout.getCurrentLayoutName();

      const hoveredZone = Z.getMenuByHoveredLayer(layoutType, document.hoveredLayer);

      // console.log('hoveredZone', hoveredZone);

      if (hoveredZone) {
        if ((hoveredZone === "shower_custom"
          || hoveredZone === "vanity_custom"
          || hoveredZone === "bathtub_custom"
          || hoveredZone === "shower_combo"
          || hoveredZone === "shower_pony_wall"
          || hoveredZone === "wall_b_custom"
          || hoveredZone === "left_wall_custom")
          && !this.state.showNavigation
        ) {
          if (this.state.contextMenuOpen) {
            this.setState({
              contextMenuOpen: false,
              hoveredLayer: {}
            });
          } else {
            let contextMenuOpen = '';
            let ponyWallGroup = false;
            switch (hoveredZone) {
              case "shower_custom":
              case "shower_combo":
              case "shower_pony_wall": {
                const showerGroup = this.state.designNavigationItems.find(navItem => {
                  return navItem.text === "Shower"
                });
                contextMenuOpen = showerGroup.part.showerTubComboIsActive() ? "Shower Tub Combo" : "Shower";
                if (hoveredZone === "shower_pony_wall") {
                  ponyWallGroup = true;
                }
                break;
              }
              case "vanity_custom":
                contextMenuOpen = "Vanity";
                break;
              case "bathtub_custom":
                contextMenuOpen = "Bathtub";
                break;
              case "left_wall_custom":
                contextMenuOpen = "Shower Body Selection";
                break;
              case "wall_b_custom":
                contextMenuOpen = "wall_b_custom";
                break;
            }
            this.openContextMenu(contextMenuOpen, ponyWallGroup, event);
          }
          return false;
        } else if (this.state.contentType === 0) {
          this.setState({
            showNavigation: true,
            contentType: ContentType.Design,
            contextMenuOpen: false,
            hoveredLayer: {}
          }, () => {
            this.setNewActiveFeature();
            this.menuOpened();
            setTimeout(() => {
              $(document).on('click', this.handleWrapperBlur);
            }, 0)
          });
        }

        hoveredZone.child
          ? this.triggerOpenNavigationMenu(hoveredZone.child, hoveredZone.parent)
          : this.triggerOpenNavigationMenu(hoveredZone)

      }

    }

  };

  openContextMenu = (contextMenuOpen, ponyWallGroup, event) => {
    const hoveredParent = this.state.designNavigationItems.find(navItem => {
      return navItem.text === contextMenuOpen
    });
    let contextMenuButtons = [];
    if (contextMenuOpen === "Shower Body Selection") {
      contextMenuButtons = this.getShowerBodySelectionButtons()
    } else if (contextMenuOpen === "wall_b_custom") {
      contextMenuButtons = [1, 2, 3]
    } else {
      contextMenuButtons = hoveredParent.part.subParts();
    }
    if (contextMenuOpen === "Shower" || contextMenuOpen === "Shower Tub Combo") {
      contextMenuButtons = contextMenuButtons.filter(menuButton => {
        return ponyWallGroup ? menuButton.part.isPonyWallPart && menuButton.part.partId !== "pony_wall" : !menuButton.part.isPonyWallPart
      });
    }
    if (contextMenuOpen === "Vanity") {
      contextMenuButtons = contextMenuButtons.filter(menuButton => {
        return menuButton.part.partId !== "vanity_mirror" && menuButton.part.partId !== "vanity_backsplash";
      });
    }

    const isMobile = $(window).width() < 991;

    let left = isMobile ? '50%' : event.clientX - 50;
    let top = isMobile ? '50%' : event.clientY - 50;
    let right = 'auto';

    const maxAllowedWidth = contextMenuButtons.length > 2 ? 300 : 210;

    let maxAllowedHeight = 110;
    if (contextMenuButtons.length > 6) {
      maxAllowedHeight = 330;
    } else if (contextMenuButtons.length > 3) {
      maxAllowedHeight = 220;
    }
    if (!isMobile && (left > window.innerWidth - maxAllowedWidth)) {
      left = 'auto';
      right = 0
    }
    if (!isMobile && (top > window.innerHeight - maxAllowedHeight)) {
      let negativeMargin = 50;
      if (contextMenuButtons.length > 6) {
        negativeMargin = 250;
      } else if (contextMenuButtons.length > 3) {
        negativeMargin = 150;
      }
      top = top - negativeMargin;
    }
    this.setState({
      contextMenuPonyWall: ponyWallGroup,
      contextMenuOpen,
      hoveredLayer: document.hoveredLayer,
      contextMenuPosition: {
        left,
        right,
        top,
      }
    });
  };

  handleNavigationItemClick = (item, ignoreLocked = false, featureIsLocked, event) => {

    if (this.state.childNavigationItem
      && this.state.childNavigationItem.part.activeFeature
      && Array.isArray(this.state.childNavigationItem.part.activeFeature.metaData["SkuName"])
      && this.state.childNavigationItem.part.activeFeature.metaData["SkuName"][0]
      && Array.isArray(item.part.metaData["SkuName"])
      && (this.state.childNavigationItem.part.activeFeature.metaData["SkuName"][0] === item.part.metaData["SkuName"][0])) {
      this.showPositionsPopup(item, event); // move modal to new position
      return false // don't change L to R // redundant click
    }

    const layout = getCurrentLayout();
    this.navigationItemClickCommon(item); // set active feature

    const showPositionPopup = this.showPositionsPopup(item, event);
    if (showPositionPopup) {
      return // don't click on feature!! we are clicking inside the modal window
    }

    const updateSideBarIds = ["shower_body", "wall_configuration", "vanity_cabinet"];
    if (updateSideBarIds.includes(item.part.partId)) {
      this.updateSideBar();
    }
    if (this.state.parentNavigationItem && this.state.parentNavigationItem.text === "Shower Tub Combo"
      && item.part.bottomTubId && (this.state.parentNavigationItem.part.bottomTub !== item.part.bottomTubId)) {
      this.updateSideBar();
    }

    // console.log('this.state.parentNavigationItem', this.state.parentNavigationItem);
    // console.log('this.state.parentNavigationItem.part.subParts()', this.state.parentNavigationItem && this.state.parentNavigationItem.part && this.state.parentNavigationItem.part.subParts());

    if (item.matchesMetaFailed) {
      let nonCompatibleWith = "";
      switch (item.part.partId) {
        case "vanity_faucet":
          nonCompatibleWith = "sink";
          break;
        case "sink":
          nonCompatibleWith = "vanity";
          break;
        case "shower_pod":
          nonCompatibleWith = "Window Kit";
          break;
        case "window_kits":
          nonCompatibleWith = item.matchesMetaFailed === "shower_pod" ? "Shower Pod" : "Corner Shelf";
          break;
        default:
          break;
      }
      this.callMetaMathesFailedPopup(item, nonCompatibleWith);
    } else if (item.part.partId === "vanity_sink" && this.state.parentNavigationItem.part.faucet
      && this.state.parentNavigationItem.part.faucet.placeholderChanged
      && this.state.parentNavigationItem.part.faucet.activeFeature) {

      const sinkSizeConditionValue = item.part.metaData["SinkSize"][0];

      if (this.state.parentNavigationItem.part.faucet.activeFeature.matchesMetaForCondition('SinkSize', sinkSizeConditionValue)) {
        this.itemClick(item, ignoreLocked)
      } else {
        this.callMetaMathesFailedPopup(item, 'faucet');
      }
    } else if (item.part.partId === "toilet") {
      const vanity = layout.parts[Vanity.id];
      const counterTopSize = vanity.counterTopSize();
      if (counterTopSize === "60in" || counterTopSize === "72in") {
        this.callToiletFailPopup('toilet', item, ignoreLocked)
      } else {
        this.itemClick(item, ignoreLocked)
      }
    } else if (item.part.partId === "vanity_cabinet") {
      // let toilet = layout.parts[Toilet.id];
      // if (toilet) {
      //   toilet = toilet.toilet; // toiletBody
      // }
      // const counterTopSize = item.part.vanitySize + 'in';
      // const vanity = layout.parts[Vanity.id];
      // const currentCounterTopSize = vanity.counterTopSize();
      // if (toilet && toilet.placeholderChanged && (counterTopSize === "60in" || counterTopSize === "72in")
      //   && (currentCounterTopSize !== "60in" && currentCounterTopSize !== "72in")) {
      //   this.callToiletFailPopup('vanity', item, ignoreLocked)
      // } else {
      //   this.itemClick(item, ignoreLocked);
      // }
      this.itemClick(item, ignoreLocked);
      if (this.props.fabricatorSettings
        && (this.props.fabricatorSettings.wizardConsumers || (this.props.fabricatorSettings.wizardClients && document.kvConfig.isBackend))
      ) {
        if (!featureIsLocked && !item.part.partName.includes("laceholder")) {
          this.setWizardFiltersFromActiveItem(item.part)
        }
      }
    } else if (item.part.partId === "shower_interior_wall") {
      if (!featureIsLocked && !item.part.partName.includes("laceholder")) {
        this.setWizardFiltersFromActiveItem(item.part)
      }
      this.itemClick(item, ignoreLocked)
    } else {
      this.itemClick(item, ignoreLocked)
    }

    if (this.state.parentNavigationItem) {  // update canvas only if it is child
      this.props.refreshCB();
    }
  };

  render() {
    const layout = getCurrentLayout();
    // const fabricatorSettings = this.props.fabricatorSettings;
    const activePart = this.state.parentNavigationItem ? this.state.parentNavigationItem.part : null;
    const activeSubPart = this.state.childNavigationItem ? this.state.childNavigationItem.part : null;
    // const activeNavPart = activeSubPart || activePart;
    const parentItems = layout.designNavigationItems();  // parent list without filters

    const useWizard = false, wizardGroups = [];

    let showNavigationFiltersSteps = false;

    if (activeSubPart && activeSubPart.canUseNavigationFilterSteps
      && activeSubPart.canUseNavigationFilterSteps()) {
      showNavigationFiltersSteps = !this.props.countertopNavigationFilterCompleted;
    }

    const showLockedView = this.currentActiveItemIsLocked(useWizard);

    const useFilters = false;
    const availableNavButtons = [ContentType.Design, ContentType.Layout, ContentType.DisplayRoom];
    if (window.location.href.includes("new_bathroom_2021.quotesflooring") || document.kvConfig.userId === 140045) {
      availableNavButtons.push(ContentType.RoomScene)
    }

    return (
      <div className={classNames('nav-overlay', {'nav-overlay--fullwidth': this.state.showNavigation})}>
        <div
          className={classNames('nav', {'nav--opened': this.state.showNavigation}, 'nav--' + this.state.contentType)}>
          <div className="nav-wrapper" ref={(node) => this.navWrapper = node}>
            <div className="nav-wrapper__content">
              <div className="nav-wrapper__content-body">
                {this.content(useWizard, wizardGroups, useFilters, activePart, activeSubPart)}
              </div>
              <button className="nav-wrapper__content-close" onClick={this.closeNavigation}/>
            </div>
            {this.navigationMenuButtons(availableNavButtons)}
            {showNavigationFiltersSteps ? null : (
              <div className="nav-wrapper__select" onClickCapture={this.handleMobileSelectClick}>
                <MobileMenuSelect parentItems={parentItems}
                                  desktop={true}
                                  opened={this.state.showNavigation}
                                  activePart={activePart}
                                  activeSubPart={activeSubPart}
                                  onSubPartClick={this.handleSubPartClick}
                                  onParentItemClick={this.handleParentItemClick}/>
              </div>
            )}
            {/*<div className="nav-wrapper__search">*/}
            {/*<div className="search">*/}
            {/*<input className={"search-input" + (this.state.searchText ? " search-input--no-icon" : "")}*/}
            {/*value={this.state.searchText}*/}
            {/*onChange={this.handleSearchInputChange} placeholder="search"/>*/}
            {/*</div>*/}
            {/*</div>*/}
          </div>
          {this.state.contextMenuOpen && !this.state.contextMenuOpen.module
            ? <ContextMenu contextMenuOpen={this.state.contextMenuOpen}
                           hoveredLayer={this.state.hoveredLayer}
                           designNavigationItems={this.state.designNavigationItems}
                           contextMenuPonyWall={this.state.contextMenuPonyWall}
                           contextMenuPosition={this.state.contextMenuPosition}
                           handleContextMenuClick={this.handleContextMenuClick}
                           closeContextMenu={this.closeContextMenu}
                           renderGreenLayerByZindex={this.props.renderGreenLayerByZindex}
            />
            : null}
        </div>
        {this.props.bvOpened ? <NavItemPositionModal activeFeature={this.props.activeFeature}/> : null}
        {showLockedView
          ? <LockedView setActiveFeature={this.resetActiveFeature} handleUserLoginClick={this.handleUserLoginClick}/>
          : null}
      </div>
    )
  }

}

const mapStateToProps = (store) => ({
  filtersVisible: store.filterState.showFilters,
  filterGroups: store.filterState.filterGroups,
  bvPresets: store.bathroomVisualizerState.bvPresets,
  bvOpened: store.bathroomVisualizerState.bvOpened,
  userIsLoggedIn: store.userState.userIsLoggedIn,
  isPhoneNumberValidated: store.userState.isPhoneNumberValidated,
  activeNavigationFilter: store.navigationState.activeNavigationFilter,
  countertopNavigationFilterCompleted: store.navigationState.countertopNavigationFilterCompleted,
  visualizerTutorialStep: store.tutorialState.visualizerTutorialStep,
  visualizerTutorialIsOpened: store.tutorialState.visualizerTutorialIsOpened,
  activeQuoteIndex: store.quotesState.activeQuoteIndex,
  navItemPositionModal: store.navigationState.navItemPositionModal,
});

const mapDispatchToProps = {
  setNavigationViewType,
  toggleDesktopNavigation,
  setActiveNavigationNames,
  setModuleContextMenuType,
  setActiveNavigationFilter,
  setActiveNavigationFilterStepIndex,
  setDefaultSelectionGroup,
  changeActivePartRelatedItemIndex,
  setVisualizerTutorialStep,
  showVisualizerTutorial,
  setNavigationLoading,
  toggleNavItemPositionModal
};

export default connect(mapStateToProps, mapDispatchToProps)(DesktopNavigation);
